import axios from 'axios'
import { getCurrentLocation } from '@helpers/geo-location'

const CART_SERVICE_URL = process.env.GATSBY_CART_SERVICE_URL

/* ********** CART REQUESTS ********** */

export const createCart = async body => {
  const response = await axios.post(`${CART_SERVICE_URL}/cart`, body)
  return response.data
}

export const getCart = async (id, updateStoreCart = false) => {
  const response = await axios.get(`${CART_SERVICE_URL}/cart/${id}${updateStoreCart ? '?updateStoreCart=true' : ''}`)
  return response.data
}

export const editCart = async (id, body) => {
  const response = await axios.put(`${CART_SERVICE_URL}/cart/${id}`, body)
  return response.data
}

export const clearCart = async id => {
  const response = await axios.delete(`${CART_SERVICE_URL}/cart/${id}/items`)
  return response.data
}

export const deleteCart = async id => {
  const response = await axios.delete(`${CART_SERVICE_URL}/cart/${id}`)
  return response.data
}

export const getSplitCheck = async (id, zipCode) => {
  const zip = zipCode || getCurrentLocation()?.zip
  if (!id || !zip) return false

  const response = await axios.get(`${CART_SERVICE_URL}/cart/${id}/split-check/${zip}`)
  return response.data?.splitDelivery ?? false
}

/* ********** CART LINE ITEM REQUESTS ********** */

export const addItemsToCart = async (id, body) => {
  const response = await axios.post(`${CART_SERVICE_URL}/cart/${id}/items`, body)
  return response.data
}

export const getCartLineItems = async id => {
  const response = await axios.get(`${CART_SERVICE_URL}/cart/${id}/items`)
  return response.data
}

export const getCartItem = async (id, lineItemId) => {
  const response = await axios.get(`${CART_SERVICE_URL}/cart/${id}/items/${lineItemId}`)
  return response.data
}

export const editCartItem = async (id, lineItemId, body) => {
  const response = await axios.put(`${CART_SERVICE_URL}/cart/${id}/items/${lineItemId}`, body)
  return response.data
}

export const removeCartItem = async (id, lineItemId) => {
  const response = await axios.delete(`${CART_SERVICE_URL}/cart/${id}/items/${lineItemId}`)
  return response.data
}

export const removeItemsFromCart = async (id, body) => {
  const response = await axios.delete(`${CART_SERVICE_URL}/cart/${id}/items`, {
    data: body,
  })
  return response.data
}
